<template>
  <div>
    <!-- <div class="d-flex">
      <v-btn
        v-for="(button, index) in getButtons"
        :key="index"
        :class="{
          roundedCornersLeft: index === 0,
          roundedCornersRight: index === getButtons.length - 1,
        }"
        class="flex-grow-1"
        :color="button.color"
        tile
        depressed
        :outlined="$vuetify.theme.dark"
        @click.stop="$emit(button.emit, button)"
      >
        <v-icon v-if="button.icon" left>{{ button.icon }}</v-icon>
        <v-badge
          :content="button.badge"
          :value="button.badge ? button.badge : 0"
          inline
          left
          :color="button.badgeColor"
        >
          {{ button.name }}
        </v-badge>
      </v-btn>
    </div> -->

    <v-row no-gutters>
      <v-col
        v-for="(button, index) in getButtons"
        :key="index"
        :cols="12 / getButtons.length"
      >
        <v-btn
          :class="{
            roundedCornersLeft: index === 0,
            roundedCornersRight: index === getButtons.length - 1,
          }"
          :color="button.color"
          tile
          depressed
          :outlined="$vuetify.theme.dark"
          block
          @click.stop="$emit(button.emit, button)"
        >
          <v-icon v-if="button.icon" left>{{ button.icon }}</v-icon>
          <v-badge
            :content="button.badge"
            :value="button.badge ? button.badge : 0"
            inline
            left
            :color="button.badgeColor"
          >
            {{ button.name }}
          </v-badge>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { buttonObject } from "@/types/interface";

export default Vue.extend({
  props: {
    buttons: {
      type: Array as () => Array<buttonObject>,
      default: null,
    },
  },
  computed: {
    getButtons(): Array<buttonObject> {
      return this.buttons.filter((x: buttonObject) => x.show);
    },
  },
});
</script>
